var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button type-button",class:{ disabled: _vm.isDisabled },attrs:{"disabled":_vm.isDisabled,"view":_vm.view,"action":_vm.action},on:{"click":_vm.onButtonClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }